
import {fetchingTag, attachTagInAssignment, attachTagInCourse, attachTagInCRM, attachTagInClient, attachTagInStaff} from '@/api/tag.js'

export const Tag = {
  data () {
    return {
      tagModuleWise:[],
      tagSelected:[],
      oldtagSelected:[]

    }
  },
  methods:{

    async fetchTag (module, tagsData = []) {
      try {

        //homework =13
        //Reports=12
        //Exam =17
        const platform_module_id = module
        
        
        const customerId =  this.$store.getters.customerId
        const payload = {
          platform_module_id
        }
        const {data} = await fetchingTag(customerId, payload)
        if (tagsData.length !== 0) {
          const res2 = tagsData
          const res1 = data.data.tags 
          const result  = res1.filter(function (o1) {
            return res2.some(function (o2) {
              return o1.id === o2.tag_id
            })
          })
          if (result.length > 0) {
            for (let i = 0; i < result.length; i++) {
              const idToRemove = result[i].id
              data.data.tags = data.data.tags.filter(
                (item) => item.id !== idToRemove
              )
            }
          }
          this.tagModuleWise = data.data.tags
          this.tagSelected = result 
          this.oldtagSelected = result
        } else {
          const res2 = this.tagSelected
          const res1 = data.data.tags 
          const result  = res1.filter(function (o1) {
            return res2.some(function (o2) {
              return o1.id === o2.id
            })
          })
          if (result.length > 0) {
            for (let i = 0; i < result.length; i++) {
              const idToRemove = result[i].id
              data.data.tags = data.data.tags.filter(
                (item) => item.id !== idToRemove
              )
            }
          }
          this.tagModuleWise = data.data.tags
          // this.tagSelected = result  
          // this.oldtagSelected = result
          
        }
        // this.tagModuleWise = data.data.tags  
        // this.tagSelected = result 
        // this.oldtagSelected = result
        // 
        // 

      } catch (error) {
        
      } 
    },
    async filterTagList (module, tagsData = []) {
      try {
        this.getModuleId = module
        const platform_module_id = module
        const customerId =  this.$store.getters.customerId
        const payload = {
          platform_module_id
        }
        const {data} = await fetchingTag(customerId, payload)
        this.tagModuleWise = data.data.tags 
        if (tagsData.length > 0) {
          for (let i = 0; i < tagsData.length; i++) {
            const idToRemove = tagsData[i]
            this.tagModuleWise = this.tagModuleWise.filter(
              (item) => item.id !== idToRemove
            )
          }
        } else {
          for (let i = 0; i < this.tagSelected.length; i++) {
            const idToRemove = this.tagSelected[i].id
            this.tagModuleWise = this.tagModuleWise.filter(
              (item) => item.id !== idToRemove
            )
          }
        }
      } catch (error) {
        
      }
    },
    checkingTagChanges ()  {
      const isTagChange = this._.isEqual(this.tagSelected
        , this.oldtagSelected)
      

      if (isTagChange) {
        this.$vs.notify({
          title: 'Warning',
          text: 'You didnt created any tag ',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
      } else {
        this.attachTag()
      }

    },
    async attachTag () {
      let data = ''
      let NotificationText = ''
      const customerId =  this.$store.getters.customerId
      try {
        if (this.platform_module_id === 3) {
          const editing_type = this.$route.params.editing_type
          const editing_type_id = this.$route.params.editing_object.id
          
          // 
          // 
          // 

          let type_for_notification_text = ''
          if (editing_type === 'Course') {
            type_for_notification_text = 'course'
          } else if (editing_type === 'lessons') {
            type_for_notification_text = 'lesson'
          } else if (editing_type === 'topics') {
            type_for_notification_text = 'topic'
          }

          NotificationText = `Tag attached in this ${ type_for_notification_text } successfully`
          const payload = 
        {
          tag_ids:this.tagSelected,
          course_id: editing_type === 'Course' ? editing_type_id : null,
          lesson_id: editing_type === 'lessons' ? editing_type_id : null,
          topic_id: editing_type === 'topics' ? editing_type_id : null,
          type: editing_type === 'Course' ? 1 : editing_type === 'lessons' ? 2 : editing_type === 'topics' ? 3 : 4,
          platform_module_id:this.platform_module_id
        }
            
          data = await attachTagInCourse(customerId, payload)
        } else if (this.platform_module_id == 1) {
         
          const tagId = this.tagSelected.map(ele => {
            
            return ele.id
          })
          
          const payload = 
          {
            ids:[this.leadId],
            tag_ids:tagId
          }
          data = await attachTagInCRM(this.$store.getters.customerId, payload)
          NotificationText = 'Tag attached in this Lead successfully'
        } else if (this.platform_module_id == 4) {
          const tagId = this.tagSelected.map(ele => {
            return ele.id
          })
          
          const payload = 
          {
            ids:[this.client_id],
            tag_ids:tagId
          }
          data = await attachTagInClient(this.$store.getters.customerId, payload)
          NotificationText = 'Tag attached in this Client successfully'
        } else if (this.platform_module_id == 38) {
         
          const tagId = this.tagSelected.map(ele => {
            
            return ele.id
          })
          
          const payload = 
          {
            ids:[this.teacher_id],
            tag_ids:tagId
          }
          data = await attachTagInStaff(this.$store.getters.customerId, payload)
          NotificationText = 'Tag attached in this Staff successfully'
        } else if (this.platform_module_id == 48) {
          const tagId = this.tagSelected.map(ele => {
            return ele.id
          })
          
          const payload = 
          {
            ids:[this.client_id],
            tag_ids:tagId
          }
          data = await attachTagInClient(this.$store.getters.customerId, payload)
          NotificationText = 'Tag attached in this student successfully'
        } else {
          const payload = 
          {
            tag_ids:this.tagSelected,
            assignment_builder_id: this.assignment_id_to_edit,
            platform_module_id:this.platform_module_id
          }
          
            
          data = await attachTagInAssignment(customerId, payload)
          
        }
        
        this.$vs.notify({
          title: 'Success',
          text: NotificationText,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
        // const tagsselected = data.tag.map(tag => {
        //   return tag.tag_id
        // })
        // this.tagSelected = tagsselected
        // this.oldtagSelected = tagsselected 
        
        // 
        // const tagsselected = data.data.map(tag => {
        //   return tag.tag_id
        // })
        // 
        // this.tagSelected = tagsselected
        // this.oldtagSelected = tagsselected

        this.fetchTag(this.platform_module_id)

        // this.oldtagSelected = this.tagSelected
      
      } catch (error) {
        
      }
    }
    
  }
}